namespace TabAurous.HR {
    export interface HolidayListForm {
        Code: Serenity.StringEditor;
        StartDate: Serenity.DateEditor;
        EndDate: Serenity.DateEditor;
        Description: Serenity.StringEditor;
        Holidays: HolidaysEditor;
    }

    export class HolidayListForm extends Serenity.PrefixedContext {
        static formKey = 'HR.HolidayList';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!HolidayListForm.init)  {
                HolidayListForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = HolidaysEditor;

                Q.initFormType(HolidayListForm, [
                    'Code', w0,
                    'StartDate', w1,
                    'EndDate', w1,
                    'Description', w0,
                    'Holidays', w2
                ]);
            }
        }
    }
}
